import { Injectable } from '@angular/core';
import {UserService} from '../user/user.service';
import {ResourcesService} from '../resources.service';
import {Observable} from 'rxjs/Observable';
import {UserAccount} from '../../model/user-account';

@Injectable()
export class AccountService {

  constructor(
    private _resources: ResourcesService,
    private _user: UserService) { }

  getAgentList(): Observable<UserAccount[]> {
    return this._resources.get('account/AgentList?agentId=' + this._user.userAccountTypeDefault.agent.id);
  }

  userAccountCreate(userAccount: UserAccount): Observable<UserAccount> {
    return this._resources.post('account/agent/create', {
      agentId: this._user.userAccountTypeDefault.agent.id,
      userAccount: userAccount
    });
  }

  userAccountEdit(userAccount: UserAccount): Observable<UserAccount> {
    return this._resources.post('account/agent/edit', {
      agentId: this._user.userAccountTypeDefault.agent.id,
      userAccount: userAccount
    });
  }

  userAccountDelete(userAccount: UserAccount): Observable<UserAccount> {
    return this._resources.post('account/agent/delete', {
      agentId: this._user.userAccountTypeDefault.agent.id,
      userAccount: userAccount
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/account/account.service.ts